import React, { useState, useEffect, useMemo, useCallback } from "react"
import { Table, Col, Row, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from "reactstrap"
import api from "API/Api"
import SweetAlert from "react-bootstrap-sweetalert"
import PageLoader from "./../../assets/loading/pageLoad1.gif"
import { usePermissions } from "API/PermissionContext"

const TransportBills = () => {
  const { canAdd, canEdit, canDelete, MODULE } = usePermissions()
  const MID = MODULE.TRANSPORT_BILLS
  const [bills, setBills] = useState([])
  const [pageLoad, setPageLoad] = useState(true)
  const [confirm_alert, setconfirm_alert] = useState(false)
  const [success_dlg, setsuccess_dlg] = useState(false)
  const [dlgMsg, setDlgMsg] = useState("")
  const [search, setSearch] = useState("")
  const [selected, setSelected] = useState([])
  const [page, setPage] = useState(1)

  const [showFilter, setShowFilter] = useState(false)
  const [filterVehicle, setFilterVehicle] = useState("")
  const [filterDateFrom, setFilterDateFrom] = useState("")
  const [filterDateTo, setFilterDateTo] = useState("")
  // Add/Edit modal state
  const [addEditModal, setAddEditModal] = useState(false)
  const [editId, setEditId] = useState(null)
  const [aeCompany, setAeCompany] = useState("")
  const [aePlant, setAePlant] = useState("")
  const [aeCC, setAeCC] = useState("")
  const [aeBillDate, setAeBillDate] = useState(new Date().toISOString().split("T")[0])
  const [aeVehicle, setAeVehicle] = useState("")
  const [aeFrom, setAeFrom] = useState("")
  const [aeTo, setAeTo] = useState("")
  const [aeSaving, setAeSaving] = useState(false)
  const [aePlants, setAePlants] = useState([])
  const [aeCCs, setAeCCs] = useState([])
  // Modal state
  const [summaryModal, setSummaryModal] = useState(false)
  const [smTransporter, setSmTransporter] = useState("")
  const [smPlant, setSmPlant] = useState("")
  const [smCC, setSmCC] = useState("")
  const [smVehicle, setSmVehicle] = useState("")
  const [smFrom, setSmFrom] = useState("")
  const [smTo, setSmTo] = useState("")
  const [smBankAccount, setSmBankAccount] = useState("")
  const [smBankAccounts, setSmBankAccounts] = useState([])
  const [smFormat, setSmFormat] = useState("")
  const [smPreview, setSmPreview] = useState(null)
  const [summaryLoading, setSummaryLoading] = useState(false)
  const [smCompany, setSmCompany] = useState("")
  const [modalPlants, setModalPlants] = useState([])
  const [modalCCs, setModalCCs] = useState([])
  // Master data
  const [transporters, setTransporters] = useState([])
  const [vehicles, setVehicles] = useState([])
  const [companies, setCompanies] = useState([])
  const [plants, setPlants] = useState([])
  const [allCCs, setAllCCs] = useState([])
  const perPage = 50
  const a = r => { const d = r.data?.data; return Array.isArray(d) ? d : d?.data || [] }

  const fetchData = useCallback(async () => {
    setPageLoad(true)
    try {
      const [billsR, tR, vR, cR, pR, ccR] = await Promise.all([
        api.get("transport-bills?per_page=500"),
        api.get("transporters?per_page=500"),
        api.get("vehicles?per_page=500"),
        api.get("companies"),
        api.get("plants"),
        api.get("centers"),
      ])
      setBills(a(billsR)); setTransporters(a(tR)); setVehicles(a(vR))
      setCompanies(a(cR)); setPlants(a(pR)); setAllCCs(a(ccR))
    } catch (e) { console.error(e) }
    setPageLoad(false)
  }, [])
  useEffect(() => { fetchData() }, [fetchData])

  // Cascading helpers
  const onModalCompanyChange = async v => { setSmCompany(v); setSmPlant(""); setSmCC(""); setModalPlants([]); setModalCCs([]); if (v) { try { setModalPlants(a(await api.get("plants-by-company/" + v))) } catch(e){} } else { setModalPlants(plants) } }
  const onModalPlantChange = async v => { setSmPlant(v); setSmCC(""); setModalCCs([]); if (v) { try { setModalCCs(a(await api.get("chillings-by-plant/" + v))) } catch(e){} } }
  const onModalCCChange = v => { setSmCC(v) }
  const loadBankAccounts = async (companyId) => { if (!companyId) { setSmBankAccounts([]); return }; try { const r = await api.get("company-bank-accounts/" + companyId); setSmBankAccounts(Array.isArray(r.data?.data) ? r.data.data : []) } catch(e) { setSmBankAccounts([]) } }
  const showModalCompany = companies.length > 1

  // Dropdown close on outside click
  const [showDlDrop, setShowDlDrop] = useState(false)
  useEffect(() => {
    const h = () => setShowDlDrop(false)
    document.addEventListener("click", h)
    return () => document.removeEventListener("click", h)
  }, [])

  // Search + filter
  const filtered = useMemo(() => bills.filter(b => {
    if (filterVehicle && !(b.vehicleNumber || "").toLowerCase().includes(filterVehicle.toLowerCase()) && !(b.vehicleName || "").toLowerCase().includes(filterVehicle.toLowerCase())) return false
    if (filterDateFrom && b.billDate < filterDateFrom) return false
    if (filterDateTo && b.billDate > filterDateTo) return false
    if (search) {
      const s = search.toLowerCase()
      return [b.vehicleName, b.vehicleNumber, b.transporterName, b.billDate, b.billFrom, b.billTo, b.billAmount].some(v => (v || "").toString().toLowerCase().includes(s))
    }
    return true
  }), [bills, filterVehicle, filterDateFrom, filterDateTo, search])

  const totalPages = Math.max(1, Math.ceil(filtered.length / perPage))
  const paged = filtered.slice((page - 1) * perPage, page * perPage)
  const allSelected = paged.length > 0 && paged.every(b => selected.includes(b.id))
  const toggleAll = () => { allSelected ? setSelected(selected.filter(id => !paged.find(b => b.id === id))) : setSelected([...new Set([...selected, ...paged.map(b => b.id)])]) }
  const toggleOne = id => setSelected(prev => prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id])

  // Bulk delete
  const handleBulkDelete = async () => {
    if (!selected.length) return
    try {
      const r = await api.post("delete-multiple-transport-bills", { items: selected })
      if (r.data.success) { setBills(prev => prev.filter(b => !selected.includes(b.id))); setSelected([]); setDlgMsg(r.data.data); setsuccess_dlg(true) }
    } catch (e) { console.error(e); alert("Failed to delete") }
  }

  // Add/Edit modal cascading
  const onAeCompanyChange = async v => { setAeCompany(v); setAePlant(""); setAeCC(""); setAePlants([]); setAeCCs([]); if (v) { try { setAePlants(a(await api.get("plants-by-company/" + v))) } catch(e){} } else { setAePlants(plants) } }
  const onAePlantChange = async v => { setAePlant(v); setAeCC(""); setAeCCs([]); if (v) { try { setAeCCs(a(await api.get("chillings-by-plant/" + v))) } catch(e){} } }
  const openAddModal = () => { setEditId(null); setAeCompany(""); setAePlant(""); setAeCC(""); setAeBillDate(new Date().toISOString().split("T")[0]); setAeVehicle(""); setAeFrom(""); setAeTo(""); setAePlants([]); setAeCCs([]); setAddEditModal(true) }
  const openEditModal = async (bill) => { setEditId(bill.id); setAeCompany(""); setAePlant(""); setAeCC(String(bill.chillingCenter || "")); setAeBillDate(bill.billDate || ""); setAeVehicle(String(bill.vehicle || "")); setAeFrom(bill.billFrom || ""); setAeTo(bill.billTo || ""); setAePlants([]); setAeCCs([]); setAddEditModal(true) }
  const handleGenerate = async () => {
    if (!aeVehicle) { alert("Please select a Pickup Vehicle"); return }
    if (!aeBillDate) { alert("Bill Date is required"); return }
    if (!aeFrom || !aeTo) { alert("Bill Period From and To are required"); return }
    if (aeFrom > aeTo) { alert("Bill Period 'From' must be before 'To'"); return }
    setAeSaving(true)
    try {
      const payload = { vehicle: aeVehicle, billDate: aeBillDate, billFrom: aeFrom, billTo: aeTo, chillingCenter: aeCC || undefined, billAmount: "0" }
      // Find transporter from selected vehicle
      const veh = vehicles.find(v => String(v.id) === String(aeVehicle))
      if (veh) payload.transporter = veh.transporter
      if (editId) {
        const r = await api.put("update-transport-bill/" + editId, payload)
        if (r.data.success) { setAddEditModal(false); fetchData(); setDlgMsg("Transport Bill Updated!"); setsuccess_dlg(true) }
      } else {
        const r = await api.post("create-transport-bill", payload)
        if (r.data.success) { setAddEditModal(false); fetchData(); setDlgMsg("Transport Bill Added!"); setsuccess_dlg(true) }
      }
    } catch (e) { console.error(e); alert("Failed to save. Check all fields.") }
    setAeSaving(false)
  }

  // Summary modal
  const openSummaryModal = () => { setSummaryModal(true); setSmPreview(null); setSmTransporter(""); setSmCompany(""); setSmPlant(""); setSmCC(""); setSmVehicle(""); setSmFrom(""); setSmTo(""); setSmFormat(""); setSmBankAccount(""); setSmBankAccounts([]); setModalPlants([]); setModalCCs([]); if (companies.length > 0) loadBankAccounts(companies[0].id) }
  const handlePreview = async () => {
    if (!smFrom || !smTo) { alert("Bill Period From and To are required"); return }
    setSummaryLoading(true); setSmPreview(null)
    try {
      const payload = { billFrom: smFrom, billTo: smTo, transporter: smTransporter || undefined, vehicle: smVehicle || undefined }
      const r = await api.post("transport-summary-download", payload)
      setSmPreview(r.data)
    } catch (e) { console.error(e); alert("Failed to load preview") }
    setSummaryLoading(false)
  }
  const handleDownload = () => {
    if (!smPreview?.data?.length) { alert("No data to download. Click Preview first."); return }
    const d = smPreview.data
    const h = ["#", "Transporter", "Vehicle", "Vehicle No", "Bill Date", "Period From", "Period To", "Fuel", "Toll", "Other", "Bill Amount", "Remarks"]
    const rows = d.map((r, i) => [i + 1, r.transporterName, r.vehicleName, r.vehicleNumber, r.billDate, r.billFrom, r.billTo, r.fuelCharges, r.tollCharges, r.otherCharges, r.billAmount, r.remarks || ""])
    const csv = [h, ...rows].map(r => r.map(c => `"${(c == null ? "" : c).toString().replace(/"/g, '""')}"`).join(",")).join("\n")
    const ext = smFormat === "excel" ? ".xls" : ".csv"
    const b = new Blob([csv], { type: smFormat === "excel" ? "application/vnd.ms-excel" : "text/csv" })
    const link = document.createElement("a"); link.href = URL.createObjectURL(b)
    link.download = `transport_summary_${smFrom}_to_${smTo}${ext}`; link.click()
  }

  // Icon button helper
  const ib = (bg, icon, title, onClick, dis) => <button title={title} onClick={onClick} disabled={dis} style={{ width: "32px", height: "32px", borderRadius: "4px", background: bg, color: "#fff", border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "14px", cursor: "pointer", opacity: dis ? 0.5 : 1 }}><i className={`fas ${icon}`}></i></button>

  // Dropdown button helper
  const dropBtn = (bg, icon, title, show, setShow, items) => (
    <div style={{ position: "relative", display: "inline-block" }}>
      <button title={title} onClick={e => { e.stopPropagation(); setShow(!show) }} style={{ width: "32px", height: "32px", borderRadius: "4px", background: bg, color: "#fff", border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "14px", cursor: "pointer" }}>
        <i className={`fas ${icon}`}></i><i className="fas fa-caret-down" style={{ fontSize: "8px", marginLeft: "2px" }}></i>
      </button>
      {show && <div style={{ position: "absolute", top: "36px", left: 0, background: "#fff", border: "1px solid #e2e8f0", borderRadius: "6px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", zIndex: 1000, minWidth: "280px", padding: "4px 0" }}>
        {items.map((item, i) => <div key={i} onClick={() => { item.action(); setShow(false) }} style={{ padding: "8px 16px", cursor: "pointer", fontSize: "13px", whiteSpace: "nowrap" }} onMouseEnter={e => e.target.style.background = "#f1f5f9"} onMouseLeave={e => e.target.style.background = "transparent"}>{item.label}</div>)}
      </div>}
    </div>
  )

  if (pageLoad) return <div className="pageLoader"><img src={PageLoader} alt="Loading..." /></div>

  return (
    <>
      <div className="dashBody">
        {/* Single toolbar row */}
        <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px", marginBottom: "12px" }}>
          <h4 style={{ margin: 0, fontWeight: 600, whiteSpace: "nowrap", marginRight: "4px" }}>Transport Bills</h4>
          {canAdd(MID) && ib("#2e7d32", "fa-plus", "Add Transport Bill", openAddModal, false)}
          {canDelete(MID) && ib("#dc3545", "fa-trash-alt", "Delete Selected", () => { if (!selected.length) { alert("Select at least one bill"); return }; setconfirm_alert(true) }, !selected.length)}
          {dropBtn("#e65100", "fa-file-export", "Transport Summary", showDlDrop, setShowDlDrop, [
            { label: "Transport Bill Bank Format Download", action: openSummaryModal },
          ])}
          <button title={showFilter ? "Hide Filters" : "Show Filters"} onClick={() => { setShowFilter(f => { if (f) { setFilterVehicle(""); setFilterDateFrom(""); setFilterDateTo("") } return !f }) }}
            style={{ width: "32px", height: "32px", borderRadius: "4px", background: showFilter ? "#0d6efd" : "#6c757d", color: "#fff", border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "14px", cursor: "pointer" }}>
            <i className="fas fa-filter"></i>
          </button>
          <div style={{ flex: 1 }}></div>
          <input type="text" placeholder="Search" value={search} onChange={e => { setSearch(e.target.value); setPage(1) }} style={{ border: "1px solid #dee2e6", borderRadius: "4px 0 0 4px", padding: "4px 10px", fontSize: "13px", width: "160px", height: "32px" }} />
          {ib("#0d6efd", "fa-search", "Search", null, false)}
        </div>

        <div className="table-responsive">
          <Table className="table mb-0 dairyTbl" style={{ fontSize: "13px" }}>
            <thead style={{ background: "#f8f9fa" }}>
              <tr>
                <th style={{ width: "30px" }}><input type="checkbox" checked={allSelected} onChange={toggleAll} /></th>
                <th style={{ width: "40px" }}>#</th>
                <th>Vehicle</th>
                <th>Bill Date</th>
                <th>Bill Period From</th>
                <th>Bill Period To</th>
                <th>Bill Amount</th>
                <th style={{ width: "80px" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {showFilter && (
                <tr style={{ background: "#f0f4ff" }}>
                  <td></td><td></td>
                  <td><input type="text" className="form-control form-control-sm" placeholder="Vehicle..." value={filterVehicle} onChange={e => setFilterVehicle(e.target.value)} /></td>
                  <td><input type="date" className="form-control form-control-sm" value={filterDateFrom} onChange={e => setFilterDateFrom(e.target.value)} /></td>
                  <td><input type="date" className="form-control form-control-sm" value={filterDateTo} onChange={e => setFilterDateTo(e.target.value)} /></td>
                  <td></td><td></td>
                  <td><button className="btn btn-sm btn-outline-danger" title="Clear filters" onClick={() => { setFilterVehicle(""); setFilterDateFrom(""); setFilterDateTo("") }}><i className="fa fa-times"></i></button></td>
                </tr>
              )}
              {paged.length > 0 ? paged.map((b, i) => (
                <tr key={b.id || i}>
                  <td><input type="checkbox" checked={selected.includes(b.id)} onChange={() => toggleOne(b.id)} /></td>
                  <td>{(page - 1) * perPage + i + 1}</td>
                  <td>{b.vehicleName || b.vehicleNumber || "-"}</td>
                  <td style={{ whiteSpace: "nowrap" }}>{b.billDate}</td>
                  <td style={{ whiteSpace: "nowrap" }}>{b.billFrom}</td>
                  <td style={{ whiteSpace: "nowrap" }}>{b.billTo}</td>
                  <td style={{ fontWeight: "600" }}>₹{b.billAmount || "0"}</td>
                  <td style={{ whiteSpace: "nowrap" }}>
                    {canEdit(MID) && <i className="fas fa-edit icons icon-edit" style={{ cursor: "pointer" }} onClick={() => openEditModal(b)}></i>}
                  </td>
                </tr>
              )) : (
                <tr><td colSpan={8} style={{ textAlign: "center", padding: "20px", color: "#b45309" }}>No matching records found</td></tr>
              )}
            </tbody>
          </Table>
        </div>

        {/* Pagination */}
        <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "4px", marginTop: "12px" }}>
          <button className="btn btn-sm btn-outline-secondary" disabled={page <= 1} onClick={() => setPage(1)}>«</button>
          <button className="btn btn-sm btn-outline-secondary" disabled={page <= 1} onClick={() => setPage(page - 1)}>‹</button>
          {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
            const p = Math.max(1, Math.min(page - 2, totalPages - 4)) + i
            return p <= totalPages ? <button key={p} className={`btn btn-sm ${p === page ? "btn-primary" : "btn-outline-secondary"}`} onClick={() => setPage(p)}>{p}</button> : null
          })}
          <button className="btn btn-sm btn-outline-secondary" disabled={page >= totalPages} onClick={() => setPage(page + 1)}>›</button>
          <button className="btn btn-sm btn-outline-secondary" disabled={page >= totalPages} onClick={() => setPage(totalPages)}>»</button>
        </div>
      </div>

      {/* Add/Edit Transport Bill Modal */}
      <Modal isOpen={addEditModal} toggle={() => setAddEditModal(false)} size="md">
        <ModalHeader toggle={() => setAddEditModal(false)}>Transport Bills <span style={{ color: "#dc3545", fontSize: "13px" }}>[* required]</span></ModalHeader>
        <ModalBody>
          {showModalCompany && <Row className="mb-3"><Col md={6}><label className="fw-bold" style={{ fontSize: "13px" }}>Company</label><select className="form-control form-control-sm mt-1" value={aeCompany} onChange={e => onAeCompanyChange(e.target.value)}><option value="">Select</option>{companies.map((c, i) => <option key={i} value={c.id}>{c.name}</option>)}</select></Col></Row>}
          <Row className="mb-3">
            <Col md={6}><label className="fw-bold" style={{ fontSize: "13px" }}>Plant</label><select className="form-control form-control-sm mt-1" value={aePlant} onChange={e => onAePlantChange(e.target.value)}><option value="">Select</option>{(aeCompany ? aePlants : plants).map((p, i) => <option key={i} value={p.id}>{p.name}</option>)}</select></Col>
            <Col md={6}><label className="fw-bold" style={{ fontSize: "13px" }}>Allocated Chilling Center</label><select className="form-control form-control-sm mt-1" value={aeCC} onChange={e => setAeCC(e.target.value)}><option value="">Select</option>{(aePlant ? aeCCs : allCCs).map((c, i) => <option key={i} value={c.id}>{c.name}</option>)}</select></Col>
          </Row>
          <Row className="mb-3">
            <Col md={6}><label className="fw-bold" style={{ fontSize: "13px" }}>Bill Date *</label><input type="date" className="form-control form-control-sm mt-1" value={aeBillDate} onChange={e => setAeBillDate(e.target.value)} /></Col>
            <Col md={6}><label className="fw-bold" style={{ fontSize: "13px" }}>Pickup Vehicles *</label><select className="form-control form-control-sm mt-1" value={aeVehicle} onChange={e => setAeVehicle(e.target.value)}><option value="">Nothing selected</option>{vehicles.map((v, i) => <option key={i} value={v.id}>{v.driverName} — {v.vehicleNumber}</option>)}</select></Col>
          </Row>
          <Row className="mb-3">
            <Col md={6}><label className="fw-bold" style={{ fontSize: "13px" }}>Bill Period From *</label><input type="date" className="form-control form-control-sm mt-1" value={aeFrom} onChange={e => setAeFrom(e.target.value)} /></Col>
            <Col md={6}><label className="fw-bold" style={{ fontSize: "13px" }}>Bill Period To *</label><input type="date" className="form-control form-control-sm mt-1" value={aeTo} onChange={e => setAeTo(e.target.value)} /></Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-success" onClick={handleGenerate} disabled={aeSaving}>{aeSaving ? <><Spinner size="sm" /> Saving...</> : "Generate"}</button>
          <button className="btn btn-danger" onClick={() => setAddEditModal(false)}>Close</button>
        </ModalFooter>
      </Modal>

      {/* Transport Bill Bank Format Download Modal */}
      <Modal isOpen={summaryModal} toggle={() => setSummaryModal(false)} size="lg">
        <ModalHeader toggle={() => setSummaryModal(false)}>Transport Bill Bank Format Download <span style={{ color: "#dc3545", fontSize: "13px" }}>[* required]</span></ModalHeader>
        <ModalBody>
          <Row className="mb-3">
            <Col md={3}>
              <label className="fw-bold" style={{ fontSize: "13px" }}>Transporter</label>
              <select className="form-control form-control-sm mt-1" value={smTransporter} onChange={e => setSmTransporter(e.target.value)}>
                <option value="">Select</option>
                {transporters.map((t, i) => <option key={i} value={t.id}>{t.transporterName}</option>)}
              </select>
            </Col>
            {showModalCompany && <Col md={2}><label className="form-label" style={{ fontSize: "13px" }}>Company</label><select className="form-control form-control-sm" value={smCompany} onChange={e => { onModalCompanyChange(e.target.value); loadBankAccounts(e.target.value || (companies.length > 0 ? companies[0].id : null)) }}><option value="">All</option>{companies.map((c, i) => <option key={i} value={c.id}>{c.name}</option>)}</select></Col>}
            <Col md={showModalCompany ? 2 : 3}>
              <label className="form-label" style={{ fontSize: "13px" }}>Plant</label>
              <select className="form-control form-control-sm" value={smPlant} onChange={e => onModalPlantChange(e.target.value)}>
                <option value="">All</option>
                {(smCompany ? modalPlants : plants).map((p, i) => <option key={i} value={p.id}>{p.name}</option>)}
              </select>
            </Col>
            <Col md={showModalCompany ? 2 : 3}>
              <label className="form-label" style={{ fontSize: "13px" }}>Allocated Chilling Center</label>
              <select className="form-control form-control-sm" value={smCC} onChange={e => onModalCCChange(e.target.value)}>
                <option value="">All</option>
                {(smPlant ? modalCCs : allCCs).map((c, i) => <option key={i} value={c.id}>{c.name}</option>)}
              </select>
            </Col>
            <Col md={3}>
              <label className="fw-bold" style={{ fontSize: "13px" }}>Vehicle *</label>
              <select className="form-control form-control-sm mt-1" value={smVehicle} onChange={e => setSmVehicle(e.target.value)}>
                <option value="">Nothing selected</option>
                {vehicles.map((v, i) => <option key={i} value={v.id}>{v.driverName} — {v.vehicleNumber}</option>)}
              </select>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={3}><label className="form-label" style={{ fontSize: "13px" }}>Bill Period From *</label><input type="date" className="form-control form-control-sm" value={smFrom} onChange={e => setSmFrom(e.target.value)} /></Col>
            <Col md={3}><label className="form-label" style={{ fontSize: "13px" }}>Bill Period To *</label><input type="date" className="form-control form-control-sm" value={smTo} onChange={e => setSmTo(e.target.value)} /></Col>
            <Col md={3}>
              <label className="fw-bold" style={{ fontSize: "13px" }}>Company Bank Account *</label>
              <select className="form-control form-control-sm mt-1" value={smBankAccount} onChange={e => setSmBankAccount(e.target.value)}>
                <option value="">Select Bank Account</option>
                {smBankAccounts.map((b, i) => <option key={i} value={b.id}>{b.bank_name} - {b.account_number}</option>)}
              </select>
            </Col>
            <Col md={3}>
              <label className="fw-bold" style={{ fontSize: "13px" }}>Download Format Type *</label>
              <select className="form-control form-control-sm mt-1" value={smFormat} onChange={e => setSmFormat(e.target.value)}>
                <option value="">Select</option>
                <option value="csv">CSV</option>
                <option value="excel">Excel</option>
              </select>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col><button className="btn btn-primary" onClick={handlePreview} disabled={summaryLoading}>{summaryLoading ? <><Spinner size="sm" /> Loading...</> : "Preview"}</button></Col>
          </Row>
          {/* Preview table */}
          {smPreview && smPreview.data && (
            <div className="table-responsive" style={{ maxHeight: "300px", overflowY: "auto" }}>
              <Table className="table table-sm table-bordered" style={{ fontSize: "12px" }}>
                <thead style={{ background: "#f8f9fa", position: "sticky", top: 0 }}>
                  <tr><th>#</th><th>Transporter</th><th>Vehicle</th><th>Vehicle No</th><th>Bill Date</th><th>From</th><th>To</th><th>Fuel</th><th>Toll</th><th>Other</th><th>Amount</th></tr>
                </thead>
                <tbody>
                  {smPreview.data.length > 0 ? smPreview.data.map((r, i) => (
                    <tr key={i}><td>{i + 1}</td><td>{r.transporterName}</td><td>{r.vehicleName}</td><td>{r.vehicleNumber}</td><td>{r.billDate}</td><td>{r.billFrom}</td><td>{r.billTo}</td><td>₹{r.fuelCharges}</td><td>₹{r.tollCharges}</td><td>₹{r.otherCharges}</td><td style={{ fontWeight: "600" }}>₹{r.billAmount}</td></tr>
                  )) : <tr><td colSpan={11} style={{ textAlign: "center", color: "#6c757d" }}>No records found</td></tr>}
                </tbody>
                {smPreview.summary && (
                  <tfoot style={{ background: "#e8f5e9", fontWeight: "600" }}>
                    <tr><td colSpan={7}>Total ({smPreview.summary.totalRecords} records)</td><td>₹{smPreview.summary.totalFuel}</td><td>₹{smPreview.summary.totalToll}</td><td>₹{smPreview.summary.totalOther}</td><td>₹{smPreview.summary.totalBillAmount}</td></tr>
                  </tfoot>
                )}
              </Table>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-success" onClick={handleDownload} disabled={!smPreview?.data?.length}>Download Bank Format</button>
          <button className="btn btn-danger" onClick={() => setSummaryModal(false)}>Close</button>
        </ModalFooter>
      </Modal>

      {confirm_alert && <SweetAlert title="Are you sure?" warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger"
        onConfirm={() => { handleBulkDelete(); setconfirm_alert(false) }} onCancel={() => setconfirm_alert(false)}>You won't be able to revert this!</SweetAlert>}
      {success_dlg && <SweetAlert success title="Success" onConfirm={() => setsuccess_dlg(false)}>{dlgMsg}</SweetAlert>}
    </>
  )
}
export default TransportBills
